/**
 * 文件上传控件
 * @props ossType 上传文件属于哪个模块 {course 课程 , activity 活动 , avatar 头像}
 * @props isSingle 是否仅上传单个文件
 * @props maxFileSize 最大文件大小按字节计算
 * @props imageMaxWidth 最大像素宽度，超过无法上传，会有提示
 * @props imageMaxHeight 最大像素高度，超过无法上传，会有提示
 * @props imageMatchWidth 等于像素宽度，超过无法上传，会有提示
 * @props imageMatchHeight 等于像素高度，超过无法上传，会有提示
 * @props imageWidthHeightRatio 像素宽高比，误差在0.01范围内，超过无法上传，会有提示
 * @props imageMinWidth 最小像素宽度，不足无法上传，会有提示
 * @props imageMinHeight 最小像素高度，不足无法上传，会有提示 
 * @props messageTitle 提示异常的时候，标识的字段名称，避免用户不知道哪个出错
 * @emit uploadSuccess 上传成功或者删除等操作后回调，返回url路径
 */
import CUpload from './CUpload'

export default CUpload;